'use es6';

import tinymce from 'tinymce';
import ContentAssistanceAutocompletePopoverManager from '../../components/ContentAssistanceAutocompleteCommandPopover';
import { swapCommandForContent } from '../../hsautocomplete/utils';
import { getPickerComponent } from '../../utils/settings';
import { __HS_CONTENT_GENERATION } from '../../constants/plugins';
import { newlinesToParagraphs } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const addControls = (editor, brandVoiceOptions) => {
  function insertContent(generatedText) {
    const processedContent = newlinesToParagraphs(generatedText);
    swapCommandForContent(editor, processedContent);
  }
  const ContentAssistantAutocompleteMenu = getPickerComponent(editor, 'ContentAssistantAutocompleteMenu', '`ContentAssistantAutocompleteMenu` picker component is required for the content generation plugin');
  tinymce.canvas.addPopover(editor, `${__HS_CONTENT_GENERATION}generative`, {
    renderPopover: renderProps => {
      return /*#__PURE__*/_jsx(ContentAssistanceAutocompletePopoverManager, Object.assign({
        brandVoiceOptions: brandVoiceOptions,
        "data-test-id": "hs-content-generation-autocomplete-command",
        editor: editor,
        insertContent: insertContent,
        InlineAutocompleteMenu: ContentAssistantAutocompleteMenu
      }, renderProps));
    }
  });
};